import {
  keys as localStorageKeys,
  remove as removeLocalStorageItem,
} from 'lib/storage/isomorphicLocalStorage'
import {
  getExpiringDismissal,
  isExpiringDismissalActive,
  isExpiringDismissalExpired,
  setExpiringDismissal,
} from './expiringDismissalEntry'

const LAB_HEADER_BANNER_KEY_PREFIX = 'labHeaderBanner:'
const LEGACY_SITE_BANNER_DISMISSALS_KEY = 'siteBannerDismissals'

let didRemoveLegacyKeys = false

// TODO(2026-09-17): Remove legacy key cleanup after ~1 month — old map key should be gone from clients.
function removeLegacyKeys() {
  if (didRemoveLegacyKeys) return
  didRemoveLegacyKeys = true

  try {
    removeLocalStorageItem(LEGACY_SITE_BANNER_DISMISSALS_KEY)
  } catch {
    // Storage can fail in privacy modes or when quota is exhausted.
  }
}

function storageKey(bannerId: string) {
  return `${LAB_HEADER_BANNER_KEY_PREFIX}${bannerId}`
}

export function recordSiteBannerDismissal(bannerId: string, bannerEndDate: string) {
  removeLegacyKeys()
  setExpiringDismissal(storageKey(bannerId), bannerEndDate)
}

export function isBannerDismissed(bannerId: string): boolean {
  removeLegacyKeys()
  return isExpiringDismissalActive(storageKey(bannerId))
}

export function getDismissedBannerIds(): Set<string> {
  removeLegacyKeys()

  const dismissedIds = new Set<string>()

  try {
    for (const key of localStorageKeys()) {
      if (!key.startsWith(LAB_HEADER_BANNER_KEY_PREFIX)) {
        continue
      }

      const dismissal = getExpiringDismissal(key)
      if (!dismissal) {
        continue
      }

      if (isExpiringDismissalExpired(dismissal.endDate)) {
        removeLocalStorageItem(key)
        continue
      }

      dismissedIds.add(key.slice(LAB_HEADER_BANNER_KEY_PREFIX.length))
    }
  } catch {
    // Storage can fail in privacy modes or when quota is exhausted.
    return dismissedIds
  }

  return dismissedIds
}
